import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withPrefix } from 'gatsby';

import { withStyles } from '../tools/withStyles';
import { Main } from '../components/Main';
import { Secuence } from '../components/Secuence';
import { Text } from '../components/Text';
import { Fader } from '../components/Fader';

const stops = [
  { city: 'Monterrey', when: 'Vie 13 nov' },
  { city: 'Perú', when: 'Dom 15 nov' },
  { city: 'Colombia', when: 'Jue 19 nov' },
  { city: 'Costa Rica', when: 'Sáb 21 nov', here: true },
  { city: 'Ciudad de México', when: 'Dom 22 nov' }
];

const styles = theme => ({
  root: {},
  intro: {
    maxWidth: 640,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  list: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 8,
    margin: [36, 'auto', 0],
    padding: 0,
    maxWidth: 860,
    listStyle: 'none',
    textAlign: 'center',

    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: 5,
      left: 'calc((100% - 32px) / 10)',
      height: 2
    },
    '&::before': {
      right: 'calc((100% - 32px) / 10)',
      background: theme.color.background.light
    },
    '&::after': {
      width: 'calc((100% - (100% - 32px) / 5) * 0.75)',
      transformOrigin: 'left center',
      background: theme.color.secondary.main,
      boxShadow: `0 0 10px ${theme.color.secondary.main}`,
      animation: 'arwesScan 2.4s ease-in-out infinite'
    }
  },
  item: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 1 0',
    minWidth: 0,
    margin: 0,
    padding: 0
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: 132,
    marginTop: 14,
    padding: [12, 6, 10],
    border: `1px solid ${theme.color.background.light}`,
    background: 'rgba(7, 1, 15, 0.55)',
    boxSizing: 'border-box'
  },
  node: {
    position: 'relative',
    zIndex: 1,
    display: 'block',
    width: 12,
    height: 12,
    border: `2px solid ${theme.color.secondary.main}`,
    borderRadius: '50%',
    background: theme.color.background.dark,
    boxShadow: `0 0 8px ${theme.color.secondary.main}`
  },
  here: {
    '& $card': {
      color: theme.color.secondary.main,
      borderColor: theme.color.secondary.main,
      animation: 'arwesPulse 1.6s ease-in-out infinite alternate'
    },
    '& $node': {
      background: theme.color.secondary.main,
      boxShadow: `0 0 14px ${theme.color.secondary.main}`
    }
  },
  '@global': {
    '@keyframes arwesPulse': {
      from: { boxShadow: `0 0 6px ${theme.color.secondary.main}` },
      to: { boxShadow: `0 0 22px ${theme.color.secondary.main}` }
    },
    '@keyframes arwesScan': {
      '0%': { transform: 'scaleX(0.08)', opacity: 0.35 },
      '70%': { transform: 'scaleX(1)', opacity: 1 },
      '100%': { transform: 'scaleX(1)', opacity: 0.7 }
    }
  },
  index: {
    display: 'block',
    marginBottom: 6,
    fontFamily: theme.typography.secondary,
    fontSize: 11,
    letterSpacing: '0.16em',
    color: theme.color.secondary.main
  },
  city: {
    display: 'block',
    fontFamily: theme.typography.primary,
    fontSize: 12,
    letterSpacing: '0.03em',
    lineHeight: 1.25,
    textTransform: 'uppercase'
  },
  when: {
    display: 'block',
    marginTop: 8,
    fontFamily: theme.typography.secondary,
    fontSize: 11,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.color.text.main
  },
  photo: {
    display: 'block',
    width: '100%',
    maxWidth: 480,
    margin: [8, 0, 16]
  }
});

class Gira extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <Secuence stagger>
          <h1><Text>Cinco ciudades, diez días</Text></h1>
          <Fader>
            <img
              className={classes.photo}
              src={withPrefix('/images/hero-yoko.webp')}
              alt='Yoko Takahashi en la gira New Genesis'
            />
          </Fader>
          <p className={classes.intro}>
            <Text>New Genesis recorre Latinoamérica del 13 al 22 de noviembre. Costa Rica es la cuarta parada, con A Cruel Angel’s Thesis en el centro de la noche.</Text>
          </p>
          <Fader>
            <ol className={classes.list}>
              {stops.map((stop, index) => (
                <li key={stop.city} className={cx(classes.item, stop.here && classes.here)}>
                  <span className={classes.node} />
                  <div className={classes.card}>
                    <span className={classes.index}>0{index + 1}</span>
                    <span className={classes.city}>{stop.city}</span>
                    <span className={classes.when}>{stop.when}</span>
                  </div>
                </li>
              ))}
            </ol>
          </Fader>
        </Secuence>
      </Main>
    );
  }
}

export default withStyles(styles)(Gira);
